// Runtime (injetado por server.js no container) tem prioridade sobre o valor de build-time.
const rawUrl = window.__ENV__?.VITE_REACT_APP_BACKEND_URL || import.meta.env.VITE_REACT_APP_BACKEND_URL || '';
const envUrl = rawUrl.trim().replace(/\/$/, '');

const BACKEND_URL = envUrl || 'http://localhost:8000';

export default BACKEND_URL;
